import React from "react";
import { useNavigate } from "react-router";
import go_back from "assets/images/go_back_icon.svg";
import styles from "./GoBack.module.css";

function GoBack() {
  const navigate = useNavigate();
  const handleGoBack = () => {
    navigate(-1);
  };
  return (
    <div
      onClick={() => {
        handleGoBack();
      }}
      className={styles.go_back}
    >
      <img src={go_back} alt="go back" />
    </div>
  );
}

export default GoBack;
